/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Email_Footer_ManageInputs */

const he_notifications_email_footer_manage = /** @type {(inputs: Notifications_Email_Footer_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניהול העדפות התראות`)
};

const en_notifications_email_footer_manage = /** @type {(inputs: Notifications_Email_Footer_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage notification preferences`)
};

/**
* | output |
* | --- |
* | "Manage notification preferences" |
*
* @param {Notifications_Email_Footer_ManageInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_email_footer_manage = /** @type {((inputs?: Notifications_Email_Footer_ManageInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Email_Footer_ManageInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_email_footer_manage(inputs)
	return en_notifications_email_footer_manage(inputs)
});